import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../sections/Hero";
import Experience3D from "../sections/Experience3D";
import LatestDrop from "../sections/LatestDrop";
import CapsSection from "../sections/CapsSection";
import Editorial from "../sections/Editorial";
import Categories from "../sections/Categories";
import CollectionsScroll from "../sections/CollectionsScroll";
import Manifesto from "../sections/Manifesto";
import ProductStory from "../sections/ProductStory";
import Community from "../sections/Community";
import Newsletter from "../sections/Newsletter";
import Marquee from "../components/Marquee";
import Footer from "../components/Footer";

export default function HomePage() {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const t = setTimeout(() => {
                document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" });
            }, 400);
            return () => clearTimeout(t);
        }
    }, [location.hash]);

    return (
        <div data-testid="home-page">
            <Hero />
            <Marquee items={["Vantage Owners Club", "Drop 001", "Own Your Perspective", "Est. 2026", "Premium Streetwear"]} />
            <Experience3D />
            <LatestDrop />
            <CapsSection />
            <Editorial />
            <Categories />
            <CollectionsScroll />
            <Manifesto />
            <ProductStory />
            <Community />
            <Newsletter />
            <Footer />
        </div>
    );
}
